/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SiteEmissionsAvg } from './SiteEmissionsAvg';
import {
    SiteEmissionsAvgFromJSON,
    SiteEmissionsAvgFromJSONTyped,
    SiteEmissionsAvgToJSON,
    SiteEmissionsAvgToJSONTyped,
} from './SiteEmissionsAvg';

/**
 * 
 * @export
 * @interface PaginatedSiteEmissionsAvgList
 */
export interface PaginatedSiteEmissionsAvgList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSiteEmissionsAvgList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteEmissionsAvgList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteEmissionsAvgList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<SiteEmissionsAvg>}
     * @memberof PaginatedSiteEmissionsAvgList
     */
    results: Array<SiteEmissionsAvg>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedSiteEmissionsAvgList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedSiteEmissionsAvgList interface.
 */
export function instanceOfPaginatedSiteEmissionsAvgList(value: object): value is PaginatedSiteEmissionsAvgList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedSiteEmissionsAvgListFromJSON(json: any): PaginatedSiteEmissionsAvgList {
    return PaginatedSiteEmissionsAvgListFromJSONTyped(json, false);
}

export function PaginatedSiteEmissionsAvgListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSiteEmissionsAvgList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(SiteEmissionsAvgFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedSiteEmissionsAvgListToJSON(json: any): PaginatedSiteEmissionsAvgList {
    return PaginatedSiteEmissionsAvgListToJSONTyped(json, false);
}

export function PaginatedSiteEmissionsAvgListToJSONTyped(value?: PaginatedSiteEmissionsAvgList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(SiteEmissionsAvgToJSON)),
        'num_pages': value['numPages'],
    };
}

